import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { stickerUrl } from "@/components/editor/stickers/fx";
import { Chips } from "@/components/editor/stickers/StickerOptions";
import { usePackAccess } from "@/components/holiday/usePackAccess";

export const StickerGrid = ({ cat, onAdd }) => {
  const { t } = useI18n();
  const [c, setC] = useState("all");
  const { visible, locked, catLabel } = usePackAccess(cat.holiday_cats);
  const nav = useNavigate();
  const shown = cat.stickers.filter((s) => !s.pack || visible.includes(s.pack));
  const list = shown.filter((s) => c === "all" || s.cat === c);
  const pick = (s) => {
    if (locked(s.pack)) {
      toast(t("hol.locked"), { action: { label: t("hol.unlock"), onClick: () => nav("/credits#holiday-packs") } });
      return;
    }
    onAdd({ id: s.id });
  };
  return (
    <div className="space-y-2.5">
      <Chips testid="sticker-cat" items={["all", ...cat.sticker_cats, ...visible]} value={c} onChange={setC} label={(k) => catLabel(k) || t(`st.cat_${k}`)} />
      <div className="grid grid-cols-3 sm:grid-cols-4 gap-2 max-h-64 overflow-y-auto cx-scroll pr-1" data-testid="sticker-grid">
        {list.map((s, i) => (
          <button key={s.id} type="button" data-testid={`sticker-${s.id}`} title={s.text} onClick={() => pick(s)}
            className="group relative rounded-xl border border-white/10 bg-[radial-gradient(circle_at_50%_40%,rgba(47,123,255,0.14),transparent_70%)] p-2 hover:border-[#a746ff]/70 hover:bg-[#a746ff]/10 transition-[border-color,background-color,transform] duration-200 hover:-translate-y-0.5 cx-rise"
            style={{ animationDelay: `${i * 0.015}s` }}>
            <img src={stickerUrl(s.id)} alt={s.text} loading="lazy"
              className={`w-full h-14 object-contain drop-shadow-[0_6px_10px_rgba(0,0,0,0.6)] transition-transform duration-200 group-hover:scale-110 group-hover:-rotate-3 ${locked(s.pack) ? "opacity-45 grayscale-[40%]" : ""}`} />
            {locked(s.pack) && <span className="absolute top-1 right-1 grid place-items-center w-5 h-5 rounded-full bg-black/70 border border-white/20" data-testid={`sticker-lock-${s.id}`}><Lock className="w-3 h-3 text-amber-300" /></span>}
            <span className="block text-[9px] text-slate-400 truncate mt-1 font-mono">{s.text}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
